<template>
  <div class="fw-600 p-3 mx-auto">
    <div class="info-card info-card--w600 info-card--one-col-text-only">
      <div class="info-card__body">
        <div
          class="info-card__header bg-light-gray p-2 info-card__header--one-col"
        >
          Frequently Asked Questions
        </div>
        <div class="info-card__text--one-col">
          <!-- <ToggleControl
            toggle-id="q1"
            closed-text="How long does it usually take for my image to be selected and then published?"
            open-text="[same]"
            toggle-class="general-panel__toggle-pane--text-black bg-very-light-gray p-1"
          >
            <template v-slot:default="slotProps">
              {{ slotProps.togglerText.display }}
            </template>
          </ToggleControl>
          <b-collapse id="q1" accordion="myacc">
            <div class="pt-1 px-3">
              <p>
                asfd Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Corrupti, alias provident!
              </p>
              <p>
                Qui harum itaque dolor minus nobis beatae hic odio quisquam in
                impedit suscipit sunt repudiandae perferendis inventore, enim
                ex!
              </p>
            </div>
          </b-collapse> -->

          <!--  -->

          <!-- <ToggleControl
            toggle-id="q2"
            closed-text="Question 2"
            open-text="[same]"
            toggle-class="general-panel__toggle-pane--text-black bg-very-light-gray p-1 mt-3"
          >
            <template v-slot:default="slotProps">
              {{ slotProps.togglerText.display }}
            </template>
          </ToggleControl>
          <b-collapse id="q2" accordion="myacc"
            >Answer to
            <p>question 2</p></b-collapse
          > -->

          <div v-for="faq in faqs" :key="faq[0]">
            <ToggleControl
              :toggle-id="faq[0].toString(10)"
              :closed-text="faq[1]"
              open-text="[same]"
              toggle-class="general-panel__toggle-pane--text-black bg-very-light-gray p-1 mt-3"
            >
              <template v-slot:default="slotProps">
                {{ slotProps.togglerText.display }}
              </template>
            </ToggleControl>
            <b-collapse :id="faq[0].toString(10)" accordion="faqs">
              <div class="pt-1 px-3">{{ faq[2] }}</div></b-collapse
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleControl from '@/components/layout/ToggleControl';

export default {
  name: 'PageFAQ',
  components: {
    ToggleControl,
  },
  data: function () {
    return {
      faqs: [],
    };
  },
  created: async function () {
    console.log(6686868);
    try {
      var faqsDoc = await this.$fapi.db.collection('faqs').doc('master').get();
      var faqsObj = faqsDoc.data().all;
      console.log(faqsDoc.data().all);
      Object.keys(faqsObj)
        .sort((a, b) => a - b)
        .forEach((id) => {
          this.faqs.push([id, faqsObj[id].q, faqsObj[id].a]);
          // console.log(id);
        });
      //   this.faqs = faqsDoc.data()[2];
      // this.faqs = Object.values(faqsDoc.data().qas).sort((a, b) => a[2] - b[2]);

      // if (faqsDoc.exists) {
      //     store.dispatch('setBreeds', breedsDoc.data().all);
      // } else {
      //     throw new Error('Breeds list document does not exist in the database.')
      // }
    } catch (err) {
      console.error('Error getting faqs list:', err.message);
    }
  },
};
</script>

<style>
</style>